import { LicenseEntitlement } from '../models/owns/license';

export const useLicenseEntitlement = (entitlement: LicenseEntitlement) => {
  return true;
};
